// nameAliases.js — frontend kopie alias mapy jmen klientu (varianty zapisu stejne osoby).
// Mirror netlify/functions/_lib/nameAliases.cjs. Pouziti: filtrovani zaznamu (Log ST/Bonus)
// na klienta, kdyz se jmeno v zaznamu lisi variantou ("Zimmermanova" vs "Zimmermannova").
// EXPLICITNI aliasy, zadny fuzzy (Marta vs Martina = jine osoby).

export const NAME_ALIASES = {
  "lucie bartkova": "lucia bartkova",
  "lenja cechova": "lenka cechova", // preklep v Reserviu (13.7.2026)
  "hana koubova": "hanka koubova",
  "petra korinkova": "peta korinkova",
  "orgovanovaa andrea": "andrea orgovanova",
  "orgovanova andrea": "andrea orgovanova",
  "marta zimmermanova": "marta zimmermannova",
  "lenka kotas ostrcilova": "lenka ostrcilova",
  "latalova libuse": "libuse latalova",
};

export function normalizeName(s) {
  return String(s || "").toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/\s+/g, " ").trim();
}

// Kanonicka (po-alias) normalizovana forma jmena.
export function canonicalNorm(name) {
  const n = normalizeName(name);
  return NAME_ALIASES[n] || n;
}
